module.exports = __webpack_public_path__ + "static/media/Reference-Tse Melody-20230620.cb848826.pdf";